export type ExitVariantKind =
  | "gallery_idle_chat"
  | "gallery_idle_theory"
  | "gallery_waiting"
  | "confirm_default"
  | "confirm_no_photos"
  | "confirm_ipad_label"
  | "confirm_loading"
  | "afgesloten_loggedout"
  | "afgesloten_loggedin_named"
  | "afgesloten_loggedin_anon";

export interface ExitVariant {
  key: ExitVariantKind;
  title: string;
  desc: string;
}

// Ordering follows the user's actual journey:
//   1) sees the link in the header
//   2) opens the confirm sheet (a few copy variants)
//   3) lands on /foto/afgesloten (auth-state variants)
export const EXIT_VARIANTS: ExitVariant[] = [
  {
    key: "gallery_idle_chat",
    title: "1. Header link · chat mode",
    desc: "Stappenplan-aware gallery, exit link links naast de stap-header. Niet dominant, gray-on-white."
  },
  {
    key: "gallery_idle_theory",
    title: "2. Header link · theorie mode",
    desc: "Theorie-scope. Exit link blijft op dezelfde plek; padding klopt naast de Theorie-pill."
  },
  {
    key: "gallery_waiting",
    title: "3. Header link · waiting state",
    desc: "Desktop staat niet op een stap (Open een stap op je laptop). Link blijft zichtbaar en bruikbaar."
  },
  {
    key: "confirm_default",
    title: "4. Confirm sheet · met foto's",
    desc: "Standaardpad: gebruiker heeft minstens 1 foto gemaakt. Tekst stelt gerust dat foto's bewaard blijven."
  },
  {
    key: "confirm_no_photos",
    title: "5. Confirm sheet · zonder foto's",
    desc: "Geen foto's gemaakt; copy switcht naar 're-koppelen via QR'."
  },
  {
    key: "confirm_ipad_label",
    title: "6. Confirm sheet · iPad als desktop",
    desc: "Gekoppeld aan iPad i.p.v. laptop. 'Je verbreekt de verbinding met je iPad.'"
  },
  {
    key: "confirm_loading",
    title: "7. Confirm sheet · bezig met afsluiten",
    desc: "Confirm-knop tikt door, spinner state. Cancel disabled."
  },
  {
    key: "afgesloten_loggedout",
    title: "8. /foto/afgesloten · uitgelogd",
    desc: "Default: telefoon was niet ingelogd. Neutrale CTA naar wiswiz.nl."
  },
  {
    key: "afgesloten_loggedin_named",
    title: "9. /foto/afgesloten · ingelogd (Sara)",
    desc: "Telefoon ingelogd als Sara. CTA stuurt naar /library, kleine voornaam-touch in de tekst."
  },
  {
    key: "afgesloten_loggedin_anon",
    title: "10. /foto/afgesloten · ingelogd zonder voornaam",
    desc: "Edge case: ingelogd account zonder voornaam (bijv. ouder-account). Generieke begroeting."
  }
];
